import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useKeycloakContext } from '@wf/keycloak-axios-provider';

import { type IUserAttributes } from '../types';
import { LpcoRole } from '../constants';

import { toasterError } from '../helpers';

function useSecurity() {
  const [isValidUser, setIsValidUser] = useState(true);
  const keycloakContext = useKeycloakContext();
  const user = keycloakContext?.getUserData();
  const userAttributes: IUserAttributes = keycloakContext?.keycloak?.tokenParsed;
  const userRoles: LpcoRole[] = user?.roles?.lpco2_client;
  const navigate = useNavigate();

  useEffect(() => {
    const hasRole = (role: LpcoRole) => userRoles?.includes(role);
    const hasAttribute = (attr: keyof IUserAttributes) => !!userAttributes[attr];

    if (
      (hasRole(LpcoRole.TRADER) && !hasAttribute('TIN')) ||
      (hasRole(LpcoRole.DECLARANT) && !hasAttribute('DEC')) ||
      ([LpcoRole.OFFICER, LpcoRole.SENIOR_OFFICER, LpcoRole.CASHIER].some(hasRole) &&
        (!hasAttribute('DEP') || !hasAttribute('MIN'))) ||
      (hasRole(LpcoRole.OFFICER) && !hasAttribute('LVL'))
    ) {
      setIsValidUser(false);
    }
  }, [userAttributes, userRoles]);

  useEffect(() => {
    if (!isValidUser) {
      navigate('accessDenied');
      toasterError({ description: 'User configuration is invalid, please contact system administrator.' });
    }
  }, [isValidUser, navigate]);

  return isValidUser;
}

export default useSecurity;
